export const dataFormatTagBase = (data: any) => {
  try {
    if (!Array.isArray(data)) {
      console.error('Input data is not an array.')
      return
    }
  
    const newData = data.map(section => {
      const details: {
        bloomlevel: { name: any; markTotal: any; markScored: any }[]
        reportTheme: { name: any; markTotal: any; markScored: any }[]
        // difficultyLevel: { name: any; markTotal: any; markScored: any }[]
        // subTheme: { name: any; markTotal: any; markScored: any }[]
        // theme: { name: any; markTotal: any; markScored: any }[]
        // competencies: { name: any; markTotal: any; markScored: any }[]
        // taxonomy: { name: any; markTotal: any; markScored: any }[]
        // topic: { name: any; markTotal: any; markScored: any }[]
      } = {
        bloomlevel: [],
        reportTheme: [],
        // difficultyLevel: [],
        // subTheme: [],
        // theme: [],
        // competencies: [],
        // taxonomy: [],
        // topic: [],
      }

      
      
      section.details.forEach((question: any) => {
       
       const bloomIndex = details.bloomlevel.findIndex((b: any) => b.name === question?.bloom_level?.name)
     
       if(question.bloom_level){
        if (bloomIndex !== -1) {
          details.bloomlevel[bloomIndex].markTotal += question.candidateResult?.mark || 0
          details.bloomlevel[bloomIndex].markScored += question.candidateResult?.mark_scored || 0
        } else {
          details.bloomlevel.push({
            name: question.bloom_level.name,
            markTotal: question.candidateResult?.mark || 0,
            markScored: question.candidateResult?.mark_scored || 0,
            
          })
        }

       }

       const reportThemeIndex = details.reportTheme.findIndex((r: any) => r.name === (question?.report_theme?.name || 'Unknown'))
       if (question.report_theme) {
         if (reportThemeIndex !== -1) {
           details.reportTheme[reportThemeIndex].markTotal += question.candidateResult?.mark || 0
           details.reportTheme[reportThemeIndex].markScored += question.candidateResult?.mark_scored || 0
         } else {
           details.reportTheme.push({
             name: question.report_theme.name,
             markTotal: question.candidateResult?.mark || 0,
             markScored: question.candidateResult?.mark_scored || 0,
           })
         }
       }



        
        // const difficultyIndex = details.difficultyLevel.findIndex((d: any) => d.name === (question?.difficulty_level?.name || 'Unknown'))
        // if (question.difficulty_level) {
        //   if (difficultyIndex !== -1) {
        //     details.difficultyLevel[difficultyIndex].markTotal += question.candidateResult?.mark || 0
        //     details.difficultyLevel[difficultyIndex].markScored += question.candidateResult?.mark_scored || 0
        //   } else {
        //     details.difficultyLevel.push({
        //       name: question.difficulty_level.name,
        //       markTotal: question.candidateResult?.mark || 0,
        //       markScored: question.candidateResult?.mark_scored || 0,
        //     })
        //   }
        // }

       
        // const themeIndex = details.theme.findIndex((r: any) => r.name === (question?.theme?.name || 'Unknown'))
        // if (question.theme) {
        //   if (themeIndex !== -1) {
        //     details.theme[themeIndex].markTotal += question.candidateResult?.mark || 0
        //     details.theme[themeIndex].markScored += question.candidateResult?.mark_scored || 0
        //   } else {
        //     details.theme.push({
        //       name: question.theme.name,
        //       markTotal: question.candidateResult?.mark || 0,
        //       markScored: question.candidateResult?.mark_scored || 0,
        //     })
        //   }
        // }

        // const subThemeIndex = details.subTheme.findIndex((r: any) => r.name === (question?.sub_theme?.name || 'Unknown'))
        // if (question.sub_theme) {
        //   if (subThemeIndex !== -1) {
        //     details.subTheme[subThemeIndex].markTotal += question.candidateResult?.mark || 0
        //     details.subTheme[subThemeIndex].markScored += question.candidateResult?.mark_scored || 0
        //   } else {
        //     details.subTheme.push({
        //       name: question.sub_theme.name,
        //       markTotal: question.candidateResult?.mark || 0,
        //       markScored: question.candidateResult?.mark_scored || 0,
        //     })
        //   }
        // }


        // const competenciesIndex = details.competencies.findIndex((r: any) => r.name === (question?.competencies?.name || 'Unknown'))
        // if (question.competencies) {
        //   if (competenciesIndex !== -1) {
        //     details.competencies[competenciesIndex].markTotal += question.candidateResult?.mark || 0
        //     details.competencies[competenciesIndex].markScored += question.candidateResult?.mark_scored || 0
        //   } else {
        //     details.competencies.push({
        //       name: question.competencies.name,
        //       markTotal: question.candidateResult?.mark || 0,
        //       markScored: question.candidateResult?.mark_scored || 0,
        //     })
        //   }
        // }
        
        // const taxonomyIndex = details.taxonomy.findIndex((r: any) => r.name === (question?.tn_taxonomy?.name || 'Unknown'))
        // if (question.tn_taxonomy) {
        //   if (taxonomyIndex !== -1) {
        //     details.taxonomy[taxonomyIndex].markTotal += question.candidateResult?.mark || 0
        //     details.taxonomy[taxonomyIndex].markScored += question.candidateResult?.mark_scored || 0
        //   } else {
        //     details.taxonomy.push({
        //       name: question.tn_taxonomy.name,
        //       markTotal: question.candidateResult?.mark || 0,
        //       markScored: question.candidateResult?.mark_scored || 0,
        //     })
        //   }
        // }
       
        // const topicIndex = details.topic.findIndex((r: any) => r.name === (question?.topic?.name || 'Unknown'))
        // if (question.tn_taxonomy) {
        //   if (topicIndex !== -1) {
        //     details.topic[topicIndex].markTotal += question.candidateResult?.mark || 0
        //     details.topic[topicIndex].markScored += question.candidateResult?.mark_scored || 0
        //   } else {
        //     details.topic.push({
        //       name: question.topic.name,
        //       markTotal: question.candidateResult?.mark || 0,
        //       markScored: question.candidateResult?.mark_scored || 0,
        //       // totalMarkInSection += question.candidateResult?.mark || 0;
        //       // totalMarkScoredInSection += question.candidateResult?.mark_scored || 0;
        //     })
        //   }
        // }
      })
     
      return {
        sectionName: section.name,
        totalMark:section?.totalMarks,
        totalMarkObtained:section?.totalMarksObtained,
        details: details,
      }
    })
    console.log(newData,"new data is this ")
    return newData
  } catch (err) {
    console.error(err, ':error happened')
  }
}
